import { render, staticRenderFns } from "./testPage.vue?vue&type=template&id=7ecced52&scoped=true&"
import script from "./testPage.vue?vue&type=script&lang=js&"
export * from "./testPage.vue?vue&type=script&lang=js&"
import style0 from "./testPage.vue?vue&type=style&index=0&id=7ecced52&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecced52",
  null
  
)

export default component.exports